import { React, useState, useEffect } from "react";
import timeAgo from "../scripts/functions";
import { IoMdTime } from "react-icons/io";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Loader from "react-js-loader"; // make sure this import matches the loader you're using

export default function ItemView(params) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 700);

        return () => clearTimeout(timer); // cleanup if unmounted early
    }, []);

    if (loading) {
        return (
            <div className="loader jaza">
                <Loader type="spinner-default" bgColor="#FC7F03" size={50} />
            </div>
        );
    }

    return (
        <div className="view-content">
            <br />
            <div className="align-horizontal">
                <IoArrowBackCircleOutline className="back-button" onClick={params.action} />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <div>
                    <span className="viewTitle">{params.item['title']}</span>
                    <span className="time-ago">
                        <IoMdTime size="15" />
                        &nbsp;
                        {timeAgo(params.item['dateCreated'])}
                    </span>
                </div>
            </div>
            <br />
            <img src={params.item['thumbnail']} style={{borderRadius: "7px"}} alt="" width="100%" />
            <br />
            <span className="paragraph-style" dangerouslySetInnerHTML={{__html: params.item['description']}}></span>
            <br />
        </div>
    );
}
